/* global CompareUtil */

if (!customElements.get('compare-modal')) {
  class CompareModal extends HTMLElement {
    constructor() {
      super();
      this.compareContainer = this.querySelector('.compare-container');
      this.compareArea = this.compareContainer.querySelector('.js-compare-area');
      this.loadingSpinner = this.compareContainer.querySelector('.compare-loading-spinner');
      this.closeButtons = this.querySelectorAll('.js-compare-close');
      this.modal = this.querySelector('.details-modal');

      this.bindEvents();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._clickHandler);
    }

    bindEvents() {
      this.addEventListener('on:product-compare-modal:open', this.open.bind(this));

      this._clickHandler = this.handleClick.bind(this);
      document.addEventListener('click', this._clickHandler);

      this.closeButtons.forEach((closeButton) => {
        closeButton.addEventListener('click', this.close.bind(this));
      });

      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        document.addEventListener('shopify:section:load', CompareModal.handleSectionChange);
        document.addEventListener('on:product-compare:reload', this.renderCompareTable.bind(this));
      }
    }

    handleClick(evt) {
      if (evt.target.classList.contains('js-compare-col-remove')) {
        evt.preventDefault();

        CompareUtil.removeFromCompare(evt.target.dataset.productId.toString(), true);

        const compareCount = CompareUtil.getCompareCount();
        this.compareContainer.dataset.compareCount = compareCount;
        if (compareCount <= 1) {
          this.close();
        } else {
          this.renderCompareTable();
        }
      }
    }

    open() {
      if (this.modal) {
        this.modal.classList.remove('hidden');
        this.modal.setAttribute('open', '');
      }
      this.renderCompareTable();
      document.querySelector('html').classList.add('overflow-hidden');
    }

    close() {
      if (this.modal) {
        this.modal.classList.add('is-closing');
        setTimeout(() => {
          this.modal.removeAttribute('open');
          this.modal.classList.remove('is-closing');
          this.modal.classList.add('hidden');
        }, 300);
      }
      document.querySelector('html').classList.remove('overflow-hidden');

      const headerSection = document.querySelector('.header-section');
      if (headerSection) {
        headerSection.style.removeProperty('z-index');
      }
    }

    static handleSectionChange(evt) {
      if (evt.target.matches('.cc-compare')) {
        setTimeout(() => {
          document.dispatchEvent(new CustomEvent('on:product-compare:reload'));
        }, 1000);
      }
    }

    async renderCompareTable() {
      this.loadingSpinner.removeAttribute('hidden');
      this.loadingSpinner.removeAttribute('aria-hidden');
      this.compareArea.classList.remove('revealable--in');
      this.compareArea.innerHTML = '';

      const compareProducts = CompareUtil.getSelectedProducts();
      if (compareProducts) {
        this.compareContainer.dataset.compareCount = compareProducts.length;

        const compareProductHtmlArr = await CompareModal.getCompareProducts(compareProducts);
        const compareFieldsArr = [];

        if (compareProductHtmlArr.length > 0) {
          compareProductHtmlArr.forEach((compareProductHtml) => {
            const responseHTML = document.implementation.createHTMLDocument();
            responseHTML.documentElement.innerHTML = compareProductHtml;

            responseHTML.querySelectorAll('.shopify-section > div').forEach((compareField) => {
              if (!compareFieldsArr[compareField.dataset.compareKey]) {
                compareFieldsArr[compareField.dataset.compareKey] = [];
              }
              compareFieldsArr[compareField.dataset.compareKey].push(compareField);
            });
          });

          const compareElem = document.createElement('div');
          compareElem.className = 'compare-temp';

          Object.entries(compareFieldsArr).forEach(([key, value]) => {
            if (!value.every((elem) => !!elem.dataset.isEmptyMetafield)) {
              const compareRow = document.createElement('div');
              compareRow.className = `compare-row compare-row--${
                key.includes('metafield') ? 'metafield' : key.replace('compare-', '')
              }`;
              value.forEach((elem) => compareRow.appendChild(elem));
              compareElem.appendChild(compareRow);
            }
          });

          this.compareArea.innerHTML = compareElem.innerHTML;
        } else {
          this.compareArea.innerHTML = `Unable to compare products.${
            typeof Shopify !== 'undefined' && Shopify.designMode
              ? ' Ensure the Product Compare section is enabled.'
              : ' Please try again later.'
          }`;
        }

        setTimeout(() => {
          this.loadingSpinner.setAttribute('hidden', 'true');
          this.loadingSpinner.setAttribute('aria-hidden', 'true');
          this.compareArea.classList.add('revealable--in');
        }, 100);
      }
    }

    static async getCompareProducts(compareProducts) {
      const tempHtml = [];
      await Promise.all(
        compareProducts.map(async (product) => {
          const response = await fetch(`${product.url}?sections=product-compare`);
          if (response.ok) {
            const json = await response.json();
            const sectionHtml = json['product-compare'];

            if (sectionHtml) {
              const doc = document.implementation.createHTMLDocument();
              doc.documentElement.innerHTML = sectionHtml;

              // Extract content from <template> tag inside the section
              const templateEl = doc.querySelector('template');
              if (templateEl) {
                const container = doc.createElement('div');
                container.className = 'shopify-section';
                const templateContent = document.importNode(templateEl.content, true);
                container.appendChild(templateContent);
                tempHtml[product.id] = container.outerHTML;
              }
            }
          }
        })
      );

      const returnHtml = [];
      if (Object.keys(tempHtml).length > 0) {
        compareProducts.forEach((product) => returnHtml.push(tempHtml[product.id]));
      }

      return returnHtml;
    }
  }

  customElements.define('compare-modal', CompareModal);
}
